import React from 'react';
import { Mail, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-gray-300 border-t-2 border-red-800" id="contact">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex flex-col items-center md:items-start">
            <div className="flex items-center space-x-2 mb-4">
                 <img
                  src="/logo_header.png"
                  alt="Pig Destroyer Logo"
                  style={{
                    width: '150px',
                    height: 'auto',
                    filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 5))'
                  }}
                />
            </div>
            <p className="mb-4 text-center md:text-left">
              Bringing relentless grindcore to stages worldwide since 1997.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Instagram size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Twitter size={24} />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors">
                <Youtube size={24} />
              </a>
            </div>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-4 text-red-600">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-red-600 transition-colors">Home</a></li>
              <li><a href="/showlist" className="hover:text-red-600 transition-colors">Shows List</a></li>
              <li><a href="/links" className="hover:text-red-600 transition-colors">Links & Information</a></li>
            </ul>
          </div>
          
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold mb-4 text-red-600">Contact</h3>
            <p className="mb-4">For booking inquiries:</p>
            <a 
              href="mailto:booking@pigdestroyer.com" 
              className="flex items-center justify-center md:justify-start text-red-600 hover:text-red-500 transition-colors"
            >
              <Mail size={20} className="mr-2" />
              booking@pigdestroyer.com
            </a>
          </div>
        </div>
        
        <div className="border-t border-red-800 mt-12 pt-8 text-center">
          <p>&copy; {new Date().getFullYear()} Pig Destroyer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;